import React, { useState } from 'react';

import moment from 'moment/moment';

import { formatFigure } from 'Helpers/formatService';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function SupplierContractReportsIndexTableRow(props) {
    const [showContent, setShowContent] = useState(false);
    const toggle = () => {
        setShowContent(!showContent);
    };

    return (
        <>
            <tr key={props.supplierContract.id}>
                <td onClick={toggle} className="tw-cursor-pointer">
                    <div className="tw-flex tw-items-center tw-gap-x-1.5">
                        <div>{props.supplierContract.contractable?.name}</div>
                        <div>
                            {!!props.supplierContract.term &&
                                (!!props.supplierContract.term.payments.length > 0 || !!props.supplierContract.term.milestones.length > 0) &&
                                showContent && <ChevronUpIcon className="tw-w-1.5 tw-h-1.5" />}
                            {!!props.supplierContract.term &&
                                (!!props.supplierContract.term.payments.length > 0 || !!props.supplierContract.term.milestones.length > 0) &&
                                !showContent && <ChevronDownIcon className="tw-w-1.5 tw-h-1.5" />}
                        </div>
                    </div>
                </td>
                <td>{props.supplierContract.supplier.code}</td>
                <td>{props.supplierContract.contract_reference}</td>
                <td className="inbud-numeric-cell">{formatFigure(props.supplierContract.cashflow.total)}</td>
                <td className="inbud-date-cell">
                    {props.supplierContract.term && props.supplierContract.term.start_date
                        ? moment(props.supplierContract.term.start_date).format('DD-MM-YYYY')
                        : ''}
                </td>
                <td className="inbud-date-cell">
                    {props.supplierContract.term && props.supplierContract.term.end_date
                        ? moment(props.supplierContract.term.end_date).format('DD-MM-YYYY')
                        : ''}
                </td>
                <td>{props.supplierContract.supplier.supplier_contact.name}</td>
                <td>{props.supplierContract.supplier.supplier_contact.email}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            {!!props.supplierContract.term &&
                !!showContent &&
                props.supplierContract.term.payments.map((supplierContractPayment) => {
                    return (
                        <tr key={`${props.supplierContract.id}-payment-${supplierContractPayment.id}`} className="!tw-bg-white">
                            <td>{props.supplierContract.contractable?.name}</td>
                            <td>{props.supplierContract.supplier?.code}</td>
                            <td>{props.supplierContract.contract_reference}</td>
                            <td className="inbud-numeric-cell">{formatFigure(props.supplierContract.cashflow.total)}</td>
                            <td>
                                {props.supplierContract.term && props.supplierContract.term.start_date
                                    ? moment(props.supplierContract.term.start_date).format('DD-MM-YYYY')
                                    : ''}
                            </td>
                            <td>
                                {props.supplierContract.term && props.supplierContract.term.end_date
                                    ? moment(props.supplierContract.term.end_date).format('DD-MM-YYYY')
                                    : ''}
                            </td>
                            <td>{props.supplierContract.supplier.supplier_contact.name}</td>
                            <td>{props.supplierContract.supplier.supplier_contact.email}</td>
                            <td>Payment Milestone</td>
                            <td>{supplierContractPayment.description}</td>
                            <td className="inbud-date-cell">
                                {supplierContractPayment.due_date ? moment(supplierContractPayment.due_date).format('DD-MM-YYYY') : ''}
                            </td>
                            <td className="inbud-date-cell">
                                {supplierContractPayment.forecast_due_date ? moment(supplierContractPayment.forecast_due_date).format('DD-MM-YYYY') : ''}
                            </td>
                            <td className="inbud-date-cell">
                                {supplierContractPayment.paid_at ? moment(supplierContractPayment.paid_at).format('DD-MM-YYYY') : ''}
                            </td>
                            {/* Negative amounts stay hidden, as before. */}
                            <td className="inbud-numeric-cell">{supplierContractPayment.amount < 0 ? '' : formatFigure(supplierContractPayment.amount)}</td>
                            <td>
                                {props.supplierContract.term.owner_id
                                    ? `${props.supplierContract.term.owner.first_name} ${props.supplierContract.term.owner.last_name}`
                                    : '-'}
                            </td>
                        </tr>
                    );
                })}
            {!!props.supplierContract.term &&
                !!showContent &&
                props.supplierContract.term.milestones.map((supplierContractMilestone) => {
                    return (
                        <tr key={`${props.supplierContract.id}-payment-${supplierContractMilestone.id}`} className="!tw-bg-white">
                            <td>{props.supplierContract.contractable?.name}</td>
                            <td>{props.supplierContract.supplier?.code}</td>
                            <td>{props.supplierContract.contract_reference}</td>
                            <td className="inbud-numeric-cell">{formatFigure(props.supplierContract.cashflow.total)}</td>
                            <td>
                                {props.supplierContract.term && props.supplierContract.term.start_date
                                    ? moment(props.supplierContract.term.start_date).format('DD-MM-YYYY')
                                    : ''}
                            </td>
                            <td>
                                {props.supplierContract.term && props.supplierContract.term.end_date
                                    ? moment(props.supplierContract.term.end_date).format('DD-MM-YYYY')
                                    : ''}
                            </td>
                            <td>{props.supplierContract.supplier.supplier_contact.name}</td>
                            <td>{props.supplierContract.supplier.supplier_contact.email}</td>
                            <td>Other Milestone</td>
                            <td>{supplierContractMilestone.description}</td>
                            <td>{supplierContractMilestone.due_date ? moment(supplierContractMilestone.due_date).format('DD-MM-YYYY') : ''}</td>
                            <td>
                                {supplierContractMilestone.forecast_due_date ? moment(supplierContractMilestone.forecast_due_date).format('DD-MM-YYYY') : ''}
                            </td>
                            <td>{supplierContractMilestone.completed_date ? moment(supplierContractMilestone.completed_date).format('DD-MM-YYYY') : ''}</td>
                            {/* Negative amounts stay hidden, as before. */}
                            <td>{supplierContractMilestone.amount < 0 ? '' : formatFigure(supplierContractMilestone.amount)}</td>
                            <td>
                                {props.supplierContract.term.owner_id
                                    ? `${props.supplierContract.term.owner.first_name} ${props.supplierContract.term.owner.last_name}`
                                    : '-'}
                            </td>
                        </tr>
                    );
                })}
        </>
    );
}
